import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Row, Col, message } from 'antd';
import MovemateInput from '../MovemateInput';
import SquareButton from '../SquareButton';
import { FormattedMessage, useIntl } from 'react-intl';
import { isEmailValid } from 'sharedlibs/lib/utils/isEmailValid';
import { isPhoneNumberValid } from 'sharedlibs/lib/utils/isPhoneNumberValid';
import { sendLead } from 'sharedlibs/lib/redux';
import * as S from './styles';

const LeadsModal = ({ open }) => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const [visible, setVisible] = useState(open);
  const [email, setEmail] = useState('');
  const [emailTouched, setEmailTouched] = useState(false);
  const [firstName, setFirstName] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [phoneNumberTouched, setPhoneNumberTouched] = useState(false);
  const loading = useSelector(
    ({ bookingReducer }) => bookingReducer?.lead?.loading || false
  );

  const handleLead = async () => {
    const resp = await dispatch(sendLead(email, firstName, phoneNumber));

    if (!resp) {
      message.success(intl.formatMessage({ id: 'success.title' }));
      setVisible(false);
    } else {
      message.error(intl.formatMessage({ id: 'error.error' }));
    }
  };

  const isValid =
    isEmailValid(email) &&
    firstName.length > 0 &&
    isPhoneNumberValid(phoneNumber);

  return (
    <S.ModalWrapper
      footer={null}
      open={visible}
      closable={false}
      width={null}
    >
      <S.Container>
        <Row justify="center">
          <Col span={24}>
            <S.FormContainer>
              <S.Title>
                <FormattedMessage id="model.leadTitle" />
              </S.Title>
              <p>
                <FormattedMessage id="model.leadInfo" />
              </p>
              <MovemateInput
                name="firstName"
                value={firstName}
                onChange={(e) => setFirstName(e.target.value)}
                placeholder={intl.formatMessage({ id: 'model.firstName' })}
                style={{ marginBottom: '1em' }}
              />
              <MovemateInput
                name="email"
                value={email}
                onBlur={() => setEmailTouched(true)}
                onChange={(e) => setEmail(e.target.value)}
                placeholder={intl.formatMessage({ id: 'model.email' })}
                style={{ marginBottom: '1em' }}
              />
              {emailTouched && !isEmailValid(email) && (
                <p style={{ color: 'red' }}>
                  <FormattedMessage id="model.leadEmailValidation" />
                </p>
              )}
              <MovemateInput
                name="phoneNumber"
                value={phoneNumber}
                onBlur={() => setPhoneNumberTouched(true)}
                onChange={(e) =>
                  setPhoneNumber(e.target.value.replace(/\D/g, ''))
                }
                placeholder={intl.formatMessage({ id: 'model.phone' })}
                style={{ marginBottom: '1em' }}
              />
              {phoneNumberTouched && !isPhoneNumberValid(phoneNumber) && (
                <p style={{ color: 'red' }}>
                  <FormattedMessage id="model.leadPhoneValidation" />
                </p>
              )}
            </S.FormContainer>
            <S.BottomContainer>
              <S.ValueProps>
                <S.ValueProp>
                  <S.ValuePropIcon />
                  <S.ValuePropText>
                    <S.ValuePropTitle>
                      <FormattedMessage id="model.leadValueProp1" />
                    </S.ValuePropTitle>
                    <S.ValuePropDescription>
                      <FormattedMessage id="model.leadValueProp1Description" />
                    </S.ValuePropDescription>
                  </S.ValuePropText>
                </S.ValueProp>
                <S.ValueProp>
                  <S.ValuePropIcon />
                  <S.ValuePropText>
                    <S.ValuePropTitle>
                      <FormattedMessage id="model.leadValueProp2" />
                    </S.ValuePropTitle>
                    <S.ValuePropDescription>
                      <FormattedMessage id="model.leadValueProp2Description" />
                    </S.ValuePropDescription>
                  </S.ValuePropText>
                </S.ValueProp>
                <S.ValueProp>
                  <S.ValuePropIcon />
                  <S.ValuePropText>
                    <S.ValuePropTitle>
                      <FormattedMessage id="model.leadValueProp3" />
                    </S.ValuePropTitle>
                    <S.ValuePropDescription>
                      <FormattedMessage id="model.leadValueProp3Description" />
                    </S.ValuePropDescription>
                  </S.ValuePropText>
                </S.ValueProp>
              </S.ValueProps>
              <SquareButton
                onClick={handleLead}
                disabled={!isValid || loading}
                style={{
                  opacity: isValid ? 1 : 0.3,
                }}
              >
                <FormattedMessage id="action.startMoveMateJourney" />
              </SquareButton>
            </S.BottomContainer>
          </Col>
        </Row>
      </S.Container>
    </S.ModalWrapper>
  );
};

export default LeadsModal;
